import type { ScanQuotaDto } from '../types/dtos';
import { LINE_ITEM_LIMITS } from './line-items';

export const SCAN_ERROR_KEYS = {
  quotaExhausted: 'errors:scan.quotaExhausted',
  unreadable: 'errors:scan.unreadable',
  unavailable: 'errors:scan.unavailable',
  draftNotFound: 'errors:scan.draftNotFound',
  pdfUnreadable: 'errors:scan.pdfUnreadable',
} as const;

export type ScanErrorKey =
  (typeof SCAN_ERROR_KEYS)[keyof typeof SCAN_ERROR_KEYS];

export interface ScanErrorDetails {
  /** null when the caller is Pro (a fair-use stop): there is no Free quota to show. */
  quota?: ScanQuotaDto | null;
  fairUse?: boolean;
  retryAfter?: number;
}

export const RECEIPT_DRAFT_MAX_BYTES = 5 * 1024 * 1024;
export const RECEIPT_DRAFT_MAX_BYTES_PDF = 10 * 1024 * 1024;
export const RECEIPT_DRAFT_CONTENT_TYPES = [
  'image/jpeg',
  'application/pdf',
] as const;
export type ReceiptDraftContentType =
  (typeof RECEIPT_DRAFT_CONTENT_TYPES)[number];
export const RECEIPT_DRAFT_UPLOAD_EXPIRES_SECONDS = 300;
export const RECEIPT_SCAN_MAX_PX = 2048; // long side after the client resize
export const RECEIPT_SCAN_JPEG_QUALITY = 0.75;
export const RECEIPT_SCAN_CLIENT_TIMEOUT_MS = 28_000;
export const RECEIPT_SCAN_LOCK_BUDGET_MS = 45_000;
export const RECEIPT_SCAN_MAX_LINE_ITEMS = LINE_ITEM_LIMITS.MAX_ITEMS;
export const RECEIPT_SCAN_LINE_NAME_MAX = LINE_ITEM_LIMITS.NAME_MAX;
export const RECEIPT_SCAN_CURRENCY_PRINTED_MAX = 8;
export const SCAN_MONTH_PATTERN = /^\d{4}-\d{2}$/;
